import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function OurVision() {
  const [visible, setVisible] = useState({});
  const itemRefs = useRef([]);
  const { t } = useTranslation();

  const visionItems = [
    { tag: t("section4.sub1"), desc: t("section4.sub1desc"), num: "01", color: "bg-yellow-400 text-yellow-900", bar: "bg-yellow-50 text-yellow-900" },
    { tag: t("section4.sub2"), desc: t("section4.sub2desc"), num: "02", color: "bg-yellow-400 text-yellow-900", bar: "bg-yellow-50 text-yellow-900" },
    { tag: t("section4.sub3"), desc: t("section4.sub3desc"), num: "03", color: "bg-yellow-400 text-yellow-900", bar: "bg-yellow-50 text-yellow-900" },
    { tag: t("section4.sub4"), desc: t("section4.sub4desc"), num: "04", color: "bg-yellow-400 text-yellow-900", bar: "bg-yellow-50 text-yellow-900" },
  ];

  useEffect(() => {
    const observers = [];

    itemRefs.current.forEach((el, i) => {
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          setVisible((prev) => ({ ...prev, [i]: entry.isIntersecting }));
        },
        { threshold: 0.1 }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, [visionItems.length]); // t()로 인한 리렌더링과 무관하게 항목 수 기준으로만 재실행

  return (
    <div className="py-10">
      <div className="flex flex-col gap-2.5">
        {visionItems.map((item, index) => (
          <div
            key={item.num}
            ref={(el) => (itemRefs.current[index] = el)}
            style={{
              transition: "opacity 0.8s ease, transform 0.8s ease",
              opacity: visible[index] ? 1 : 0,
              transform: visible[index] ? "translateX(0)" : "translateX(-60px)",
            }}
            className="flex items-center"
          >
            <div className={`${item.color} rounded-l-full px-6 py-3.5 w-36 shrink-0 font-bold text-sm tracking-widest uppercase`}>
              {item.tag}
            </div>
            <div className={`${item.bar} bg-gray-50 rounded-r-full flex items-center px-3 py-3.5 md:py-3.5 flex-1 -ml-px min-w-0`}>
              <span className="text-sm font-medium truncate">{item.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}